var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      attrs: { "no-body": "", "header-tag": "header", "footer-tag": "footer" }
    },
    [
      _c("template", { slot: "header" }, [
        _c("div", { staticClass: "total-count" }, [
          _vm._v("\n      " + _vm._s(_vm.totalRows) + "\n      "),
          _c("span", { staticClass: "label" }, [_vm._v("Results found")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "search-box", class: { active: _vm.filter } },
          [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("div", { staticClass: "input-group-prepend" }, [
                  _c(
                    "div",
                    { staticClass: "input-group-text" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "search", "fixed-width": "" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("b-form-input", {
                  attrs: {
                    type: "text",
                    placeholder: "Find a result by keyword..."
                  },
                  on: { keyup: _vm.searchResults },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "clear-search",
                    on: {
                      click: function($event) {
                        return _vm.clearSearch()
                      }
                    }
                  },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "icon",
                      attrs: { icon: "times-circle", "fixed-width": "" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("b-card-body", [
        _c(
          "div",
          {
            staticClass:
              "form-inline per-page-selection d-flex align-items-center float-left"
          },
          [
            _c("b-form-select", {
              attrs: { options: _vm.pageOptions },
              on: { change: _vm.changePageSize },
              model: {
                value: _vm.perPage,
                callback: function($$v) {
                  _vm.perPage = $$v
                },
                expression: "perPage"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "ml-2 per-page-label" }, [
              _vm._v("Results Per Page")
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "float-right" }, [
          _vm.totalRows < 1000 && _vm.totalRows > 0
            ? _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-secondary ml-2",
                  on: { click: _vm.csvDownload }
                },
                [
                  !_vm.downloading
                    ? _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "file-export" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.downloading
                    ? _c("font-awesome-icon", {
                        staticClass: "icon",
                        attrs: { icon: "spinner", spin: "" }
                      })
                    : _vm._e(),
                  _vm._v("Export CSV\n      ")
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("b-table", {
        ref: "resultsTable",
        attrs: {
          "show-empty": "",
          striped: "",
          responsive: "",
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          items: _vm.doResultSearch,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          filter: _vm.filter,
          busy: _vm.loading,
          "empty-text": "There are no results to display"
        },
        on: {
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          },
          filtered: _vm.onFiltered
        },
        scopedSlots: _vm._u([
          {
            key: "top-row",
            fn: function(data) {
              return _vm._l(data.fields, function(field) {
                return _c(
                  "td",
                  { key: field.filterKey, class: field.tdClass },
                  [
                    field.filterType == "text"
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filters[field.filterKey],
                              expression: "filters[field.filterKey]"
                            }
                          ],
                          staticClass: "form-control form-control-sm",
                          attrs: { type: "text" },
                          domProps: { value: _vm.filters[field.filterKey] },
                          on: {
                            keyup: function($event) {
                              return _vm.updateColumnFilters()
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.filters,
                                field.filterKey,
                                $event.target.value
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ]
                )
              })
            }
          },
          {
            key: "labSampleReference",
            fn: function(row) {
              return [
                _vm.jobId === "all"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "a",
                          to: "/jobs/" + row.item.sample.job.jobId
                        }
                      },
                      [
                        _c(
                          "strong",
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.item.labSampleReference) +
                                "\n          "
                            ),
                            _c("font-awesome-icon", {
                              staticClass: "icon",
                              attrs: { icon: "angle-right", "fixed-width": "" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _c("span", [_vm._v(_vm._s(row.item.labSampleReference))])
              ]
            }
          },
          {
            key: "clientSampleReference",
            fn: function(row) {
              return [
                _vm.sampleId == -1
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          tag: "a",
                          to:
                            "/jobs/" +
                            row.item.sample.job.jobId +
                            "/samples/" +
                            row.item.sample.sampleId
                        }
                      },
                      [
                        _c(
                          "strong",
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(row.item.sample.clientSampleReference) +
                                "\n          "
                            ),
                            _c("font-awesome-icon", {
                              staticClass: "icon",
                              attrs: { icon: "angle-right", "fixed-width": "" }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _c("span", [
                      _vm._v(_vm._s(row.item.sample.clientSampleReference))
                    ])
              ]
            }
          },
          {
            key: "procedureName1",
            fn: function(row) {
              return [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      (
                        row.item.procedureName1 +
                        " " +
                        row.item.procedureName2
                      ).replace(/(\r\n)|\n/g, "<br>")
                    )
                  }
                })
              ]
            }
          },
          {
            key: "analyteName1",
            fn: function(row) {
              return [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      (
                        row.item.analyteName1 +
                        " " +
                        row.item.analyteName2
                      ).replace(/(\r\n)|\n/g, "<br>")
                    )
                  }
                })
              ]
            }
          },
          {
            key: "textResult",
            fn: function(row) {
              return [
                _vm._v("\n      " + _vm._s(row.item.textResult) + "\n      "),
                row.item.results
                  ? _c(
                      "ul",
                      { staticClass: "list-unstyled" },
                      _vm._l(row.item.results, function(
                        component,
                        componentIndex
                      ) {
                        return _c("li", { key: componentIndex }, [
                          _vm._v(_vm._s(component.textResult))
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "units",
            fn: function(row) {
              return [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      row.item.units
                        ? ("" + row.item.units).replace(/(\r\n)|\n/g, "<br>")
                        : ""
                    )
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-between" },
          [
            _c("span", [
              _vm._v(
                "Page " +
                  _vm._s(_vm.currentPage) +
                  " of " +
                  _vm._s(_vm.totalPages)
              )
            ]),
            _vm._v(" "),
            _c("b-pagination", {
              attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
              model: {
                value: _vm.currentPage,
                callback: function($$v) {
                  _vm.currentPage = $$v
                },
                expression: "currentPage"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "The Certificate of Analysis provided by Analytica Laboratories Limited T/A ALS NZ takes precedence over results displayed on or downloaded from this site."
          )
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b3531a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3531a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultsTable.vue
// module id = /pcS
// module chunks = 1